import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRedo } from '@fortawesome/pro-solid-svg-icons/faRedo';

import React, { useMemo } from 'react';

import classnames from 'clsx';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { noop } from 'ui-components/default-props/noop';

import { MessageDescriptorPropType } from '../../prop-types/intl';

import style from './repeat-button.module.css';

export const RepeatButton = ({
  className = '',
  actionHandler = noop,
  isSpinning = false,
  buttonClassName = '',
  ariaLabelMessageDescriptor,
  disabled = false,
}) => {
  const { formatMessage } = useIntl();

  const ariaLabel = useMemo(() => {
    if (ariaLabelMessageDescriptor) {
      return formatMessage(ariaLabelMessageDescriptor);
    }
  }, [ariaLabelMessageDescriptor, formatMessage]);

  return (
    <Button ariaLabel={ariaLabel} className={buttonClassName} disabled={isSpinning || disabled} onClick={actionHandler} theme='unstyled'>
      <FontAwesomeIcon className={classnames(className, { [style['is-loading-rate']]: isSpinning })} icon={faRedo} />
    </Button>
  );
};

RepeatButton.propTypes = {
  isSpinning: PropTypes.bool,
  actionHandler: PropTypes.func,
  className: PropTypes.string,
  buttonClassName: PropTypes.string,
  ariaLabelMessageDescriptor: MessageDescriptorPropType,
  disabled: PropTypes.bool,
};
